import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { loc } from "@/lib/localize";
import { X, ArrowRight } from "lucide-react";

const THEMES = {
  navy: "bg-navy text-white",
  gold: "bg-gold text-navy",
  blue: "bg-finblue text-white",
};

export function AnnouncementBar() {
  const { isAr } = useLang();
  const [dismissed, setDismissed] = useState(false);
  const { data: banner } = useQuery({ queryKey: ["public-banner"], queryFn: async () => (await api.get("/banner")).data, staleTime: 60000 });

  if (dismissed || !banner || !banner.active || !banner.message) return null;
  const msg = loc(banner, "message", isAr);
  const label = isAr
    ? (banner.link_label_ar || (isAr ? "اعرف المزيد" : "Learn more"))
    : (banner.link_label || "Learn more");
  const theme = THEMES[banner.theme] || THEMES.navy;

  return (
    <div className={`relative ${theme}`} data-testid="announcement-bar">
      <div className="container-tight flex items-center justify-center gap-3 px-10 py-2.5 text-center text-sm">
        <p className="font-medium">
          {msg}
          {banner.link_url && (
            <Link to={banner.link_url} className="ml-2 inline-flex items-center gap-1 font-semibold underline underline-offset-2" data-testid="announcement-link">
              {label} <ArrowRight className={`h-3.5 w-3.5 ${isAr ? "rotate-180" : ""}`} />
            </Link>
          )}
        </p>
        <button onClick={() => setDismissed(true)} className="absolute right-3 top-1/2 -translate-y-1/2 opacity-70 hover:opacity-100" aria-label="Dismiss" data-testid="announcement-dismiss">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
